import { useContext, useId, useState } from "react";
import { DatasetController } from "../../pages/DatasetEditor.page";
import { QueryCriterion } from "./queryPanel/QueryCriterion.component";
import { ContentAccordion } from "../ContentAccordion.component";
import { Icon } from "../Icon.component";
import {
    QUERY_ENDPOINTS,
    DEFAULT_QUERY_CRITERION,
    DEFAULT_INPUT_DEBOUNCE,
} from "../../data/constants";
import { quickhash } from "../../data/utils";

interface DatasetEditorQueryPanelProps {
    datasetVisible: boolean;
    toggleDatasetVisible: any;
}

export const DatasetEditorQueryPanel = (props: DatasetEditorQueryPanelProps) => {
    const { controller, instance: dataset } = useContext<any>(DatasetController);

    const addQueryCriterion = () => {
        let currentFilters = dataset.query?.filters || [];
        currentFilters.push(JSON.parse(JSON.stringify(DEFAULT_QUERY_CRITERION)));
        controller.setProperty("query.filters", currentFilters);
    };

    var [lastTimer, setLastTimer] = useState<number | undefined>(undefined);
    // close around 'idx' to persist the index in the filters array as we
    // 'map' below.
    const setCriterion = (idx: number) => {
        // the actual setter, takes "newCriterion"
        function setNewCriterion(newCriterion: any) {
            controller.setProperty(`query.filters[${idx}]`, newCriterion);
        }
        // the return function. It sets the lastTimeout, but first clears it if
        // one is active, creating a debounce.
        return (newCriterion: any) => {
            clearTimeout(lastTimer);
            // set debounce period of DEFAULT_INPUT_DEBOUNCE (as of writing: 1s)
            lastTimer = setTimeout(setNewCriterion, DEFAULT_INPUT_DEBOUNCE * 1000, newCriterion);
            setLastTimer(lastTimer);
        };
    };
    const deleteCriterion = (idx: number) => {
        return function doDelete() {
            controller.setProperty(`query.filters[${idx}]`, null);
            /* But why not do this?
            //let splicedFilters = dataset.query.filters;
            //splicedFilters.splice(idx, 1);
            //controller.setProperty("query.filters", [...splicedFilters]);
            // because react of course! Stupid bug somewhere related to key!
            */
        };
    };
    const setEndpoint = (event: any) => {
        let endpoint = event.target.value;
        controller.setProperty(`query.endpoint`, endpoint);
        controller.setProperty("query.filters", []);
    };

    return (
        <ContentAccordion
            header="Query"
            footer="&nbsp;"
            visibility={props.datasetVisible}
            setVisibilityToggle={props.toggleDatasetVisible}
            showEye={true}
        >
            <div role="form" key={quickhash(JSON.stringify(controller.instance.query.filters))}>
                <div className="mb-4">
                    <select onChange={setEndpoint} value={controller.instance.query.endpoint}>
                        {Object.keys(QUERY_ENDPOINTS).map((name) => {
                            let endpoint = QUERY_ENDPOINTS[name];
                            return <option value={name}>{endpoint.display_name}</option>;
                        })}
                    </select>
                    &nbsp;where&hellip;
                </div>
                {controller.instance?.query?.filters.map((criterion: any, idx: number) => {
                    return (
                        <QueryCriterion
                            prevCriteria={controller.instance.query.filters.slice(0, idx)}
                            endpoint={controller.instance.query.endpoint}
                            criterion={criterion}
                            setCriterion={setCriterion(idx)}
                            deleteCriterion={deleteCriterion(idx)}
                            key={`${idx}-${criterion}`}
                        />
                    );
                })}
                <Icon
                    name="plus"
                    className="btn icon bordered -mt-0.5"
                    onClick={addQueryCriterion}
                />
            </div>
        </ContentAccordion>
    );
};
